import React from 'react';

interface Props {
  text?: string;
  className?: string;
}

const ErrorDisplay: React.FC<Props> = ({
  text = 'Something went wrong...',
  className = 'h-20',
}) => {
  return (
    <div className={` ${className}`}>
      <h2 className="text-white pt-4 pb-4 text-center">{text}</h2>
    </div>
  );
};

export default ErrorDisplay;
